// src/pages/Portfolio.tsx
import React from 'react';

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";


import GetInTouch from '../components/GetInTouch';


import ProCabinetMakers from '../assets/images/portfolio/ProCabinetMakers.webp';
import ApaxStaffing from '../assets/images/portfolio/ApaxStaffing.webp';
import vvvLuxuryEvents from '../assets/images/portfolio/vvvLuxuryEvents.webp';



const Portfolio: React.FC = () => {

const seo = seoConfig.portfolio; // ✅ Load meta for this page


  return (


<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />



  {/* rts bread crumba rea start */}
  <div className="rts-breadcrumb-area-portfolio bg_image">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="baread-crumb-main-wrapper pt--100">
            <div className="inner">
              <h1 className="title rts_hero__title">portfolio</h1>
              <span className="bg-text d-none d-md-inline">Manikarn Digital</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* rts bread crumba rea end */}


  {/* rts case studyes area start */}
  <div className="rts-portfolio-grid-area column pb--40">
    <div className="container-140">
      <div className="row g-0 separetor-portfolio-bottom pl--10 pr--10">


{/* single portfolio area start */}
        <div className="col-lg-4 col-md-6 col-sm-12 col-12 pb--20">
<div className="signle-portfolio-style-four-inner">
  <a
    href="https://procabinetmakers.com/" 
    target="_blank" 
    rel="noopener noreferrer"
    className="thumbnail rts-slide-up-gsap"
  >
    <img src={ProCabinetMakers} alt="product" />
  </a>
  <div className="inner-content">
    <a>
      <h5 className="name">UX / Design / Development / Support</h5>
    </a>
  </div>
</div>
        </div>
{/* single portfolio area end */}


{/* single portfolio area start */}
        <div className="col-lg-4 col-md-6 col-sm-12 col-12 pb--20">
<div className="signle-portfolio-style-four-inner">
  <a
    href="https://apaxstaffing.com/" 
    target="_blank" 
    rel="noopener noreferrer"
    className="thumbnail rts-slide-up-gsap"
  >
    <img src={ApaxStaffing} alt="product" />
  </a>
  <div className="inner-content">
    <a>
      <h5 className="name">Design / Development</h5>
    </a>
  </div>
</div>
        </div>
{/* single portfolio area end */}


{/* single portfolio area start */}
        <div className="col-lg-4 col-md-6 col-sm-12 col-12 pb--20">
<div className="signle-portfolio-style-four-inner">
  <a
    href="https://vvvluxuryevents.com/" 
    target="_blank" 
    rel="noopener noreferrer"
    className="thumbnail rts-slide-up-gsap"
  >
    <img src={vvvLuxuryEvents} alt="product" />
  </a>
  <div className="inner-content">
    <a>
      <h5 className="name">Design / Development / Support</h5>
    </a>
  </div>
</div>
        </div>
{/* single portfolio area end */}






      </div>
    </div>
  </div>
  {/* rts case studyes area end */}




{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  


</>



  );
};

export default Portfolio;
